// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"408":"9938030d","800":"29889829"}[chunkId] + ".chunk.css";
};